<template>
  <main key="intro">
    <div class="intro" v-if="!loading">
      <!-- <header> -->
        <button class="btn playlist" @click="$emit('overview')"><i class="material-icons">playlist_play</i><span>View playlist</span></button>
        <h1 v-text="scenarioData.name"></h1>
        <img src="@/assets/intro-lady.svg" alt="View Injects" />
      <!-- </header> -->

      <div class="description" v-if="scenarioId && scenarioData.description" v-html="scenarioData.description"></div>

      <div class="button-container">
        <button @click="startScenario" class="btn large"><span>Start scenario</span> <i class="material-icons">arrow_forward</i></button>
      </div>
    </div>
    <div v-if="loading" class="loading-wrapper">
      <h1>Preparing the playlist</h1>
      <video autoplay="autoplay">
        <source :src="require('@/assets/loading@2x.mp4')" type="video/mp4" />
      </video>
    </div>
  </main>
</template>

<script>
import { scenarioMixin } from '@/mixins/scenarioMixin.js'
export default {
  name: "ScenarioIntro",
  mixins: [scenarioMixin],
  data () {
    return {
      loading: false
    }
  },
  methods: {
    startScenario() {
      this.$store.dispatch('traineeStatusModule/setViewedIntro', true);
      this.loading = true

      setTimeout(() => {
        this.$emit('done')
      }, 4000);
    }
  }
}
</script>

<style lang="scss" scoped>
main {
  overflow: visible !important;
  grid-area: playlist !important;
}
h1 {
  font-size: 24px;
  color: var(--primary);

  @media all and (min-width: 768px) {
    font-size: 32px;
  }
}
.intro {
  display: grid;
  grid-template-areas: 
    "btn   image"
    "title image"
    "descr descr"
    "start start";
  grid-template-columns: 1fr 110px;
  // margin: 0 20px;
  margin-bottom: 2em;
  grid-gap: 20px;
  
  @media all and (min-width: 768px) {
    grid-template-columns: 1fr 300px;
    grid-template-rows: auto min-content 1fr min-content;
    grid-template-areas: 
      "btn   image"
      "title image"
      "descr image"
      "descr start";
  }

  @media all and (min-width: 1024px) {
    margin: 0;
  }

  h1 {
    grid-area: title;
    display: flex;
    align-items: flex-end;
  }
  img {
    grid-area: image;
    width: 100%;
    height: auto;
  }

  .playlist {
    grid-area: btn;
    justify-self: flex-start;
  }
}

.description {
  grid-area: descr;
  // margin-bottom: 2em;
  color: var(--primary);
}

.loading-wrapper {
  margin: 0 auto;
  width: 100%;
  max-width: var(--max-width);
}

.button-container {
  grid-area: start;
  margin: 0 -15px;
  position: sticky;
  bottom: 0;

  @media all and (min-width: 768px) {
    margin: 0;
  }
}

.loading-wrapper {
  grid-area: playlist;

  video {
    max-width: 350px;
    margin: 0 auto;
    display: block;
  }
}

</style>